<template>
  <div class="container">
    <div class="h4 text-bold m-b-2" selenium="rsf-thanks-text">
      <p>Thanks {{ name }}!</p>
      <p>We've received your service request.</p>
    </div>
    <p class="c-gray70 h6">An email confirmation has been sent.</p>
  </div>
</template>

<script>
export default {
  name: 'customer-greeting',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
